module.exports = __webpack_public_path__ + "media/flags/je-2e1c62b3.svg";